module.exports = __webpack_public_path__ + "res/7-img_back.ec0b188b8d47a79f574a35f29dac54b1.png";